/*global log*/
import News from './News.svelte';
import { defaultListItem } from '../test/testData';

const div = document.createElement('DIV');
const script = document.currentScript;
script.parentNode.insertBefore(div, script);

const gitblitURL = 'https://git.ubinam.eu/gitblit/raw/news-content.git/master/';
const imgFolderURL = `${gitblitURL}images!`;

//for using gitblit images folder
function decorateImageURLs(list) {
    return list.map((val) => {
        const el = val;
        if (!el.imgURL?.startsWith('http')) {
            el.imgURL = `${imgFolderURL}${el.imgURL}`;
        }
        return el;
    });
}

function createNews(list) {
    new News({
        target: div,
        props: { news: list },
    });
}

fetch(`${gitblitURL}content-list.json`).then(async (response) => {
    let list = await response.json();
    list = decorateImageURLs(list);

    createNews(list);
}).catch((e) => {
    if (typeof log == 'object') {
        log.error(e);
    } else {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    createNews([defaultListItem]);
});

if (typeof module == 'object') {
    module.exports = {
        gitblitURL,
        imgFolderURL,
        decorateImageURLs,
    
    }
}